<template>
  <div class="flex flex-col relative pin-b mt-auto flex-no-shrink flex-no-grow border-t border-solid border-grey-lightest bg-white" style="max-height: 24rem;">

    <!--phrases_header-->
    <div class="flex flex-row h-10  pl-4 pr-4 justify-between flex-no-shrink flex-no-grow">
        <div class="self-center text-sm text-black"> Phrases </div>
        <div class="self-center h-4 w-4 cursor-pointer" @click="togglePhrases()"><img src="../../assets/collapse.png" alt="collapse button"> </div>
    </div>

    <!--phrases_navigation-->
    <div v-if="showPhrases" class="flex flex-row h-10 relative pin-t border-b-4 border-solid border-grey-lightest flex-no-shrink flex-no-grow">
        <!-- <div class="flex flex-col border-b-4 border-solid border-blue text-xs font-semibold text-blue h-10 justify-center ml-4">
            Standard
        </div> -->
        <div class="self-center font-light text-grey text-xs ml-4  "
            v-bind:class="[selectedTab === 'standard' ? 'border-b-4 border-solid border-blue text-xs font-semibold text-blue' : '',]" 
            @click="tabClicked('standard')"
        > Standard</div>
        <div class="self-center font-light text-grey text-xs ml-4"
        v-bind:class="[selectedTab === 'custom' ? 'border-b-4 border-solid border-blue text-xs font-semibold text-blue' : '',]" 
            @click="tabClicked('custom')"
        > Custom </div>
    </div>
    <!--phrase_core-->
    <div v-if="showPhrases" class="flex flex-col overflow-y-auto py-2">
        <Standard v-if="selectedTab === 'standard'"/>
        <Custom v-if="selectedTab === 'custom'"/>
    </div>
</div>
</template>

<script>
import Standard from './Standard'
import Custom from './Custom'
export default {
  components: {
    Standard,
    Custom
  },
  data () {
    return {
      showPhrases: false,
      selectedTab: 'standard'
    }
  },
  methods: {
    togglePhrases: function () {
      this.showPhrases = !this.showPhrases
    },
    tabClicked: function (tab) {
      this.selectedTab = tab
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Phrases/PhrasesMain.vue